(function(){

	var Stone = include('sortingBox.Stone');

	var StoneManager = function(stones_mc)
	{
		this.stones_mc = stones_mc;
		this.stones = [];
		
		var stone;

		Stone.prototype.STONES.forEach(function(stone_obj){
			stone = new Stone();
			
			stone.name = stone_obj.name;
			stone.mc_name = stone_obj.mc_name;


			
			stone.properties[StoneManager.prototype.CRITERIA_TYPE] = stone_obj.type;
			stone.properties[StoneManager.prototype.CRITERIA_SHAPE] = stone_obj.shape;
			stone.properties[StoneManager.prototype.CRITERIA_SIZE] = stone_obj.size;
			this.stones.push(stone);
		}.bind(this));
	};

	// Reference to the prototype
	var p = StoneManager.prototype;

	p.CRITERIA_COLOR = 0;
	p.CRITERIA_SHAPE = 1;
	p.CRITERIA_TYPE = 5;
	p.CRITERIA_SIZE = 6;

	p.COLORS = [
		Stone.prototype.COLOR_YELLOW,
		Stone.prototype.COLOR_RED,
		Stone.prototype.COLOR_BLUE,
		Stone.prototype.COLOR_GREEN,
		Stone.prototype.COLOR_WHITE,
		Stone.prototype.COLOR_PURPLE
	];
	
	p.SHAPES = [
		Stone.prototype.SHAPE_ROUND,
		Stone.prototype.SHAPE_SHARP
	];
	
	p.TYPES = [
		Stone.prototype.TYPE_STONE,
		Stone.prototype.TYPE_CRYSTAL
	];

	p.get = function(nb, criteria, arg, _ignore_stones, allow_random_obj, exclude_criterias, exclude_args)
		{
			var stone;
			var retuned_stones = [];
			if(criteria === null) criteria = -1;
			//trace(nb, criteria, arg, exclude_criterias, exclude_args, _ignore_stones);
			
			// Shuffle Stones Array
			var _stones_tmp = this.stones.concat();
			var _stones = [];
			while (_stones_tmp.length > 0)
			{
				_stones.push(_stones_tmp.splice(Math.floor(Math.random()*_stones_tmp.length), 1)[0]);
			}
			
			var _stone;
			for (var i = 0; i<nb ;i++)
			{
				for(var j = 0; j < _stones.length; j++)
				{
					stone = _stones[j];

					if (!allow_random_obj && stone.properties[StoneManager.prototype.CRITERIA_TYPE] == Stone.prototype.TYPE_OBJECT)
					{
						//trace(stone, "is obejct");
						continue;
					}
					
					// Check if not in retuned_stones
					var is_in_retuned_stones = false;
					for(var a = 0; a < retuned_stones.length; a++)
					{
						var returned_stone = retuned_stones[a];
						if (returned_stone.mc_name == stone.mc_name)
						{
							is_in_retuned_stones = true;
							break;
						}
					}
					if (is_in_retuned_stones)
					{
						//trace(stone, "is in retuned_stones");
						continue;
					}
					
					// Check ignore stone
					if (_ignore_stones !== null)
					{
						var is_in_ignore_stone = false;
						for(var b = 0; b < _ignore_stones.length; b++)
						{
							var _ignore_stone = _ignore_stones[b];
							if (_ignore_stone.mc_name == stone.mc_name)
							{
								is_in_ignore_stone = true;
								break;
							}
						}
						if (is_in_ignore_stone)
						{
							//trace(stone, "is in _ignore_stones");
							continue;
						}
					}
					
					// Check Exclude criteria
					if (exclude_criterias !== null && exclude_args !== null)
					{
						var is_matching_ignore =false;
						for (var k=0; k<exclude_criterias.length ;k++)
						{
							if (stone.properties.hasOwnProperty(exclude_criterias[k]) && stone.properties[exclude_criterias[k]] == exclude_args[k])
							{
								//trace(stone, "match", exclude_args[k]);
								is_matching_ignore = true;
								break;
							}
						}
						if (is_matching_ignore)
						{
							continue;
						}
					}
					
					_stone = stone.copy();
					// init criteria
					if (criteria >= 0 && arg !== null)
					{
						_stone.properties[criteria] = arg;
					}

					_stone.used = false;
					_stone.pickedUp = false;
					
					if (stone.properties[StoneManager.prototype.CRITERIA_TYPE] == Stone.prototype.TYPE_OBJECT)
					{
						allow_random_obj = false;
					}
					
					this.init_movieClip(_stone, exclude_criterias, exclude_args);
					retuned_stones.push(_stone);
					break;
				}
			}
			
			//trace("retuned_stones", retuned_stones);
			return retuned_stones;
		};

		p.init_movieClip = function(stone, exclude_criterias, exclude_args)
		{
			var color_name;
			if (stone.properties.hasOwnProperty(StoneManager.prototype.CRITERIA_COLOR))
			{
				color_name = stone.properties[StoneManager.prototype.CRITERIA_COLOR];
			} else {
				var colors = StoneManager.prototype.COLORS.concat();
				if (exclude_criterias !== null && exclude_args !== null)
				{
					var exclude_arg_index;

					exclude_args.forEach(function(exclude_arg){
						exclude_arg_index = colors.indexOf(exclude_arg);
						if (exclude_arg_index >=0 )
						{
							colors.splice(exclude_arg_index, 1);
						}
					});

				}
				
				var color_index = Math.floor(Math.random()*colors.length); //NumberUtil.randomInt(0, colors.length);
				stone.properties[StoneManager.prototype.CRITERIA_COLOR] = colors[color_index];
				color_name = colors[color_index];
			}



			var stone_class_name = stone.mc_name.replace("{0}",color_name);
			var underscores = stone_class_name.match(/_\w/gim);
			underscores.forEach(function(match){
				stone_class_name = stone_class_name.replace(match,match.substring(1).toUpperCase());
			});

			stone.movieClip = this.panel[stone_class_name];//.clone(true);
		};

		p.match = function(stone, criteria, arg)
		{
			var is_matching = stone.properties[criteria] !== null && stone.properties[criteria] === arg;
			return is_matching;
		};
	
	// Assign to namespace
	namespace('sortingBox').StoneManager = StoneManager;

}());